export function parseDsn(dsn) {
    let url;
    try {
        url = new URL(dsn);
    }
    catch {
        throw new Error('the DSN is not a URL');
    }
    const path = url.pathname.replace(/\/+$/, '');
    const slash = path.lastIndexOf('/');
    const projectId = path.slice(slash + 1);
    const prefix = path.slice(0, slash);
    if (!url.username || !projectId) {
        throw new Error('the DSN needs a public key and a project id');
    }
    return {
        publicKey: url.username,
        projectId,
        origin: url.origin,
        envelopeUrl: `${url.origin}${prefix}/api/${projectId}/envelope/`,
    };
}
//# sourceMappingURL=dsn.js.map